<hhsg-mapping #mappingComponent pageName="TimePayCodeMapping" entityName="Pay Code" searchByText="Client Time Pay Code Name" [sortOptions]="sortOptions" 
    [mappingService]="_timePayCodeMappingService" [(mappingForm)]="mappingForm" [getDisplayName]="getDisplayName">
    <div mappingFormBody class="body" *ngIf="mappingComponent.selection">
        <form #mappingForm="ngForm">
            <div class="form-group">
                <label>Client Time Pay Code Name</label>
                <input maxlength="75" type="text" required name="timePayCode" [disabled]="true" [(ngModel)]="mappingComponent.selection.timePayCode">
            </div>
            <div class="form-group">
                <label>Include in Actual Hours Calculation</label>
                <ul class="options">
                <li>
                    <label>
                    <input type="radio" name="hasTotalCalculation" [value]="true" [(ngModel)]="mappingComponent.selection.includeInHoursCalculation" required>Yes
                    </label>
                </li>
                <li>
                    <label>
                    <input type="radio" name="hasTotalCalculation" [value]="false" [(ngModel)]="mappingComponent.selection.includeInHoursCalculation">No
                    </label>
                </li>
                </ul>
            </div>                   
            <div class="form-group">
                <label>File Source</label>
                <input type="text" required name="payCodeSource" [disabled]="true" value="Time & Attendance">
            </div>
        </form>
    </div>
</hhsg-mapping>